import { render, staticRenderFns } from "./CRServiceRevenueTable.vue?vue&type=template&id=567a4bb1&scoped=true&"
import script from "./CRServiceRevenueTable.vue?vue&type=script&lang=js&"
export * from "./CRServiceRevenueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a4bb1",
  null
  
)

export default component.exports